/**
 * Регистрация Service Worker через VitePWA `virtual:pwa-register`.
 *
 * Режим: prompt. Новый SW не перехватывает открытое приложение и не
 * перезагружает страницу сам: production-only модуль сначала предлагает
 * пользователю безопасно применить обновление.
 *
 * Production-регистрацию держим в отдельном модуле: VitePWA не подключён к
 * dev-серверу (иначе его SPA fallback вмешивается в proxy), но во время build
 * статический `virtual:pwa-register` обязан быть виден анализатору Vite.
 */

export function registerSW(onUpdate: (apply: () => Promise<void>) => void) {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (import.meta.env.DEV) return; // в dev SW не нужен, virtual-модуля тоже нет

  void (async () => {
    try {
      const { registerProductionSW } = await import('./sw-register.prod.js');
      registerProductionSW(onUpdate);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('[sw] production registration failed', err);
    }
  })();
}
